import { createRoot } from 'react-dom/client';
import { indexName } from './SearchClient';
import HubSearchWrapper from './HubSearchWrapper';

const init = (el) => {
  const root = createRoot(el);

  if (!indexName) {
    console.warn('Algolia search index not found');
    return;
  }

  const props = window.hub_search_props;

  root.render(<HubSearchWrapper {...props} />);
};

export default init;
